import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toastSuccess } from "helpers/toastHelper";
import { RootState } from "redux/store";
import { authService } from "services";
import { Auth } from "types/Auth";

export const forgotPasswordFromStore = createAsyncThunk(
  "auth/forgotPasswordFromStore",
  async (param: Auth.ForgotPassword) => {
    return await authService.forgotPassword(param);
  }
);

type ForgotPasswordState = {
  isLoading: boolean;
  isLoaded: boolean;
};

const initialState: ForgotPasswordState = {
  isLoading: true,
  isLoaded: false,
};

export const forgotPasswordSlice = createSlice({
  name: "appState",
  initialState,
  reducers: {
    resetLoader: (state, action?) => {
      state.isLoaded = false;
    },
    resetForgotPassword: () => initialState,
  },
  extraReducers: (builder) => {
    builder

      .addCase(forgotPasswordFromStore.pending, (state, action) => {
        state.isLoading = true;
        state.isLoaded = true;
      })
      .addCase(forgotPasswordFromStore.fulfilled, (state, action) => {
        let { message } = action?.payload;
        toastSuccess(message);
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(forgotPasswordFromStore.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoaded = true;
      });
  },
});

export default forgotPasswordSlice.reducer;
export const { resetForgotPassword, resetLoader } = forgotPasswordSlice.actions;
// export const selectIsVerified = (state: RootState) =>
//   state.forgotPasswordState;
